// frontend/src/components/Login.js
import React, { useState } from 'react';
import { Form, Button, Card, Alert } from 'react-bootstrap';
import api from '../api';

function Login({ onLogin }) {
  const [step, setStep]           = useState(1); // 1 = identifiant, 2 = mot de passe
  const [username, setUsername]   = useState('');
  const [password, setPassword]   = useState('');
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);

  // Étape 1 — vérification identifiant (anti-énumération)
  const handleStepOne = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Délai fixe de 1.5s — le temps de réponse ne trahit pas si le compte existe
    await new Promise(r => setTimeout(r, 1500));

    // On passe toujours à l'étape 2, qu'il existe ou non
    setStep(2);
    setLoading(false);
  };

  // Étape 2 — authentification réelle
  const handleStepTwo = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.post('/auth/login', { username, password });
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      onLogin(response.data.user);
    } catch (err) {
      // Message générique — ne révèle pas si c'est le login ou le mdp qui est faux
      setError('Identifiants incorrects.');
      // Retour à l'étape 1 après échec
      setTimeout(() => {
        setStep(1);
        setUsername('');
        setPassword('');
        setError('');
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <Card style={{ width: '400px' }}>
        <Card.Body>
          <div className="text-center mb-4">
            <h2>🏗️ BTP Manager</h2>
            <p className="text-muted">
              {step === 1 ? 'Identification' : 'Authentification'}
            </p>
          </div>

          {error && <Alert variant="danger">{error}</Alert>}

          {/* ÉTAPE 1 — Identifiant */}
          {step === 1 && (
            <Form onSubmit={handleStepOne} autoComplete="off">
              {/* Champ honeypot caché — piège les bots qui remplissent tout */}
              <input
                type="text"
                name="username_fake"
                style={{ display: 'none' }}
                tabIndex="-1"
                autoComplete="off"
              />
              <Form.Group className="mb-3">
                <Form.Label>Identifiant</Form.Label>
                <Form.Control
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="off"
                  spellCheck="false"
                  required
                  // ❌ Plus de placeholder 'admin'
                />
              </Form.Group>
              <Button
                variant="primary"
                type="submit"
                className="w-100"
                disabled={loading}
              >
                {loading ? 'Vérification...' : 'Continuer →'}
              </Button>
            </Form>
          )}

          {/* ÉTAPE 2 — Mot de passe */}
          {step === 2 && (
            <Form onSubmit={handleStepTwo} autoComplete="off">
              <Form.Group className="mb-3">
                <Form.Label>Identifiant</Form.Label>
                <Form.Control
                  type="text"
                  value={username}
                  disabled // ✅ Affiché mais non modifiable à l'étape 2
                  autoComplete="off"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Mot de passe</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password" // ✅ Seul attribut respecté par les navigateurs
                  required
                  autoFocus
                />
              </Form.Group>
              <div className="d-flex gap-2">
                <Button
                  variant="outline-secondary"
                  className="w-25"
                  onClick={() => { setStep(1); setPassword(''); }}
                  disabled={loading}
                >
                  ←
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  className="w-75"
                  disabled={loading}
                >
                  {loading ? 'Connexion...' : 'Se connecter'}
                </Button>
              </div>
            </Form>
          )}

          {/* ❌ Supprimé : "Demo: admin / admin123" */}
        </Card.Body>
      </Card>
    </div>
  );
}

export default Login;